/* src/app/modules/spare-parts/spare-parts-filter/spare-parts-filter.component.scss */
:host {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
}
.input-wrapper,
.icon-wrapper {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 1rem;
}
.icon-wrapper {
  gap: unset;
}
#spare-parts-filter-search-input {
  width: 15.875rem;
}
/*# sourceMappingURL=spare-parts-filter.component.css.map */
